<template>
  <v-app>
   <Navbar></Navbar>
    <v-content>
      <Factura> </Factura>
    </v-content>
  </v-app>
</template>

<script>
import  Navbar from '@/components/Navbar'
import  Factura from '@/components/Factura'



export default {
  name: "App",

  components: {
Factura,
    Navbar
  },

  data: () => ({
    //
  })
};
</script>
